import { Select } from 'antd';
import ordinal from 'ordinal';

import {
  MONTHLY_DAY_ARRAY,
  SCHEDULE_PERIOD,
  WEEKDAY_MAP,
} from '@/types/commonConst';
import { SchedulePeriodMap } from '@/types/commonConst';

import { Stage } from '../Stage/Stage';
import { Span } from '../Typography';

type Props = {
  schedule: Schedule;
  setSchedule: (payload: Schedule) => void;
};

export const ScheduleSelect = (props: Props) => {
  const { schedule, setSchedule } = props;
  return (
    <div className="flex items-center gap-3">
      <Select
        options={SchedulePeriodMap.toArray()}
        value={schedule.period}
        onChange={(v) => setSchedule({ ...schedule, period: v })}
        style={{ width: 100 }}
      />
      <div className="flex items-center gap-3">
        <Stage>
          <Stage.Scene status={schedule.period === SCHEDULE_PERIOD.DAILY}>
            <Span size={2} weight="sb">
              Everyday at
            </Span>
          </Stage.Scene>
          <Stage.Scene status={schedule.period === SCHEDULE_PERIOD.MONTHLY}>
            <Select
              placeholder="Date"
              style={{ width: 80 }}
              value={schedule.date}
              options={MONTHLY_DAY_ARRAY.map((item) => ({
                value: item,
                label: ordinal(item),
              }))}
              onChange={(v) => setSchedule({ ...schedule, date: v })}
            />
          </Stage.Scene>
          <Stage.Scene status={schedule.period === SCHEDULE_PERIOD.WEEKLY}>
            <Select
              placeholder="Day"
              style={{ width: 160 }}
              value={schedule.weekday}
              options={WEEKDAY_MAP.toArray()}
              onChange={(v) => setSchedule({ ...schedule, weekday: v })}
            />
          </Stage.Scene>
        </Stage>

        <Select
          placeholder="Time"
          style={{ width: 100 }}
          value={schedule.hour}
          options={Array(24)
            .fill(null)
            .map((_, index) => {
              const label = `${index < 10 ? `0${index}` : index}:00`;
              return {
                value: index,
                label: label,
              };
            })}
          onChange={(v) => setSchedule({ ...schedule, hour: v })}
        />
      </div>
    </div>
  );
};
